<template>
  <div class="wrap">
    <div class="banner">
      <div class="text animated fadeIn">
        <p class="icon"></p>
        <p class="h2">项目服务支持</p>
      </div>
    </div>
    <div class="inner">
      <el-tabs tab-position="left">
        <el-tab-pane
          v-for="(tab, index) in serviceSupportList"
          :key="index"
          :label="tab.label"
        >
          <component :is="tab.component"></component>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import TabOxygenConcentratorWorkingPrinciple from './TabOxygenConcentratorWorkingPrinciple.vue'
import TabLiquidOxygenHazards from './TabLiquidOxygenHazards.vue'
import TabOxygenConcentratorCurrentStatus from './TabOxygenConcentratorCurrentStatus.vue'
import TabOxygenConcentratorCompliance from './TabOxygenConcentratorCompliance.vue'
import TabOxygenTherapyBenefits from './TabOxygenTherapyBenefits.vue'
import TabOxygenConcentrationFAQ from './TabOxygenConcentrationFAQ.vue'
export default {
  name: 'ServiceSupport',
  props: {
    scrollTopNum: Number
  },
  data () {
    return {
      serviceSupportList: [
        {
          label: '医用分子筛制氧机工作原理及流程',
          component: TabOxygenConcentratorWorkingPrinciple
        },
        {
          label: '传统液氧危害与制氧系统优势',
          component: TabLiquidOxygenHazards
        },
        {
          label: '医用制氧机现状及适用范围',
          component: TabOxygenConcentratorCurrentStatus
        },
        {
          label: '分子筛制氧合规性阐述',
          component: TabOxygenConcentratorCompliance
        },
        {
          label: '氧气的重要性和氧疗相关好处',
          component: TabOxygenTherapyBenefits
        },
        {
          label: '（摘抄）氧浓度≥90%问题解答',
          component: TabOxygenConcentrationFAQ
        }
      ]
    }
  },
  mounted () {

  },
  watch: {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 444px;
  margin-top: 76px;
  background: url("../../assets/images/ecg-banner.png") no-repeat center;
  text-align: center;
  overflow: hidden;
  .text {
    display: inline-block;
    margin: 117px auto 0;
  }
  .icon {
    width: 105px;
    height: 105px;
    margin: 0 auto;
    background: url("../../assets/images/banner5-icon.png") no-repeat center;
    border-radius: 50%;
    background-color: #ffffff;
  }
  .h2 {
    font-size: 30px;
    color: #fff;
    margin-top: 62px;
  }
}
.inner {
  width: 1200px;
  min-height: 1000px;
  margin: 20px auto;
  background-color: #f2f2f2;
  padding: 10px;
  /deep/ .el-tabs {
    min-height: 1000px;
    display: flex;
    .el-tabs__header {
      .el-tabs__nav{
        .el-tabs__active-bar{
          height: 0px !important;
        }
        .el-tabs__item{
          width: 260px;
          height: 60px;
          background-color: #ffffff;
          margin-bottom: 10px;
          padding: 10px;
          line-height: 25px;
          font-size: 16px;
          font-weight: bold;
          display: flex;
          align-items: center;
          cursor: pointer;
        }
      }
    }
    .el-tabs__content{
      width: 100%;
      background-color: #ffffff;
      margin-left: 20px;
      padding: 10px;
    }
    .el-tabs__item {
      width: 100%;
    }
    .el-tab-pane {
      flex: 1;
    }
    .el-tabs__item.is-active {
      background-color: #0051B3 !important;
      color: white;
    }
  }
}
/deep/ .el-tabs--left .el-tabs__nav-wrap.is-left::after,
.el-tabs--left .el-tabs__nav-wrap.is-right::after,
.el-tabs--right .el-tabs__nav-wrap.is-left::after,
.el-tabs--right .el-tabs__nav-wrap.is-right::after {
  width: 0px !important;
}
</style>
